<template>
    <RPBaseStatCard
        :title="title"
        :status="status"
        :card-link="cardLink"
        :card-link-text="cardLinkText"
        @nav="n => $emit('nav', n)"
    >
        <template v-slot:title>
            <slot name="title"></slot>
        </template>

        <template v-slot:content>
            <div class="ComparisonCard">
                <div class="ComparisonCard__left-card">
                    <slot
                        name="leftData"
                        :left-data="leftData"
                    >
                        <span class="ComparisonCard__data">
                            <slot
                                name="leftDataText"
                                :left-data="leftData"
                            >{{ leftData }}</slot>
                        </span>
                    </slot>
                    <slot
                        name="leftDescription"
                        :left-data="leftDescription"
                    >
                        <span
                            v-if="leftDescription !== ''"
                            class="ComparisonCard__description"
                        >
                            {{ leftDescription }}
                        </span>
                    </slot>
                    <slot
                        name="leftInfo"
                        :left-data="leftInfo"
                    >
                        <span
                            v-if="leftInfo !== ''"
                            class="ComparisonCard__info"
                        >
                            {{ leftInfo }}
                        </span>
                    </slot>
                </div>
                <div class="ComparisonCard__right-card">
                    <slot
                        name="rightData"
                        :right-data="rightData"
                    >
                        <span class="ComparisonCard__data">
                            {{ rightData }}
                        </span>
                    </slot>
                    <slot
                        name="rightDescription"
                        :right-data="rightDescription"
                    >
                        <span
                            v-if="rightDescription !== ''"
                            class="ComparisonCard__description"
                        >
                            {{ rightDescription }}
                        </span>
                    </slot>
                    <slot
                        name="rightInfo"
                        :right-data="rightInfo"
                    >
                        <span
                            v-if="rightInfo !== ''"
                            class="ComparisonCard__info"
                        >
                            {{ rightInfo }}
                        </span>
                    </slot>
                </div>
            </div>
        </template>
    </RPBaseStatCard>
</template>
<script>
import RPBaseStatCard from './RPBaseStatCard.vue';
import stat from 'status';

export default {
    name: 'RPComparisonCard',
    components: {
        RPBaseStatCard
    },
    props: {
        title: {
            type: String,
            default: 'Default Title'
        },
        leftData: {
            type: [String, Number],
            default: 'Info'
        },
        leftDescription: {
            type: [String, Number],
            default: ''
        },
        leftInfo: {
            type: [String, Number],
            default: ''
        },
        rightData: {
            type: [String, Number],
            default: 'Info'
        },
        rightDescription: {
            type: [String, Number],
            default: ''
        },
        rightInfo: {
            type: [String, Number],
            default: ''
        },
        cardLink: {
            type: String,
            default: '',
        },
        cardLinkText: {
            type: String,
            default: 'Report',
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
    },
};
</script>
<style lang="scss">
    .ComparisonCard {
        flex-grow: 1;
        padding: 0 1rem;
        display: flex;
        &__left-card,
        &__right-card {
            width: 100%;
            padding-bottom: 1rem;
            display: flex;
            flex-direction: column;
            align-content: center;
            justify-content: space-between;
            text-align: center;
        }
        &__left-card {
            border-right: 1px solid $grey-100;
            padding-right: 1rem;
        }
        &__right-card {
            padding-left: 1rem;
        }
        &__data {
            color: $text-dark;
            font-size: 2rem;
            margin-bottom: 0.5rem;
            flex-grow: 1;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }
        &__description {
            font-size: 0.8rem;
            color: $text-grey
        }
        &__info {
            font-size: 0.8rem;
            color: $text-grey;
            font-weight: 600;
        }
    }
</style>
